import { GUARDAR_SESION, BORRAR_SESION } from "./actionTypes";

export const guardar_sesion = sesion => ({
    type: GUARDAR_SESION,
    payload: sesion
});

export const borrar_sesion = () => ({
    type: BORRAR_SESION
});